import { ActivateEhsConfigurationInput } from "../../../hooks/useEhsConfigurationMutations";
import { PaginationQueryObject, QueryConfig } from "./Queries";

export const fetchEHSConfigurationsQuery = (
  filterInput: any,
  paginationInput: PaginationQueryObject
): QueryConfig => {
  const query = `
    query ehsConfigurations(
      $paginationInput: PaginationInput!
      $filterInput: EhsConfigurationsFilterInput
    ) {
      ehsConfigurations(
        paginationInput: $paginationInput
        filterInput: $filterInput
      ) {
        items {
          version
          description
          createdBy {
            id
          }
          dateTimeCreated
          active
          id
          name
          version
          configurationType {
            id
            name
          }
        }
        pageInfo {
          pageSize
          pageNumber
          totalElements
          totalPages
          hasNext
          hasPrevious
        }
      }
    }
  `;

  return {
    query: query,
    variables: {
      filterInput,
      paginationInput,
    },
  };
};

export const activateEhsConfigurationQuery = (
  input: ActivateEhsConfigurationInput
): QueryConfig => {
  const query = `mutation activateEhsConfig($input: ActivateEhsConfigurationInput!) {
    activateEhsConfiguration(input: $input) {
      id
    }
  }`;

  return {
    query: query,
    variables: {
      input,
    },
  };
};

export const ehsConfigurationTypesQuery = (input: {
  customerId: string;
}): QueryConfig => {
  const query = `
  query getConfigTypes($input: EhsConfigurationTypesInput!) {
    ehsConfigurationTypes(input: $input) {
      items {
        id
        name
      }
    }
  }`;

  return {
    query: query,
    variables: {
      input,
    },
  };
};

export interface EhsListsFilterInput {
  customerId: string;
  search?: string;
}

export const ehsListsQuery = (
  filterInput: EhsListsFilterInput,
  paginationInput: PaginationQueryObject
): QueryConfig => {
  const query = `query getEhsLists($filterInput: EhsListsFilterInput, $paginationInput: PaginationInput!) {
    ehsLists(filterInput: $filterInput, paginationInput: $paginationInput) {
      items {
        listType
        listTypeCode
        listItems {
          id
          item
          listOrder
          code
          description
          enabled
          shortName
          listTypeCode
        }
      }
      pageInfo {
        pageNumber
        pageSize
        totalPages
        totalElements
        hasNext
        hasPrevious
      }
    }
  }`;

  return {
    query: query,
    variables: {
      filterInput: {
        and: { customerId: filterInput.customerId },
        or: { listType: filterInput.search },
      },
      paginationInput,
    },
  };
};

export interface CreateEhsListItemInput {
  customerId: string;
  listTypeCode: string;
  enabled: boolean;
  item: string;
  code: string;
  shortName: string;
  description: string;
  listOrder: number;
}

export const createEhsListItemMutation = (
  input: CreateEhsListItemInput
): QueryConfig => {
  const query = `mutation ($input: CreateEhsListItemInput!) {
    createEhsListItem (input: $input) {
      id
      item
      listTypeCode
      enabled
    }
  }`;
  return {
    query,
    variables: { input },
  };
};

export interface UpdateEhsListItemInput {
  id: string;
  customerId: string;
  listTypeCode: string;
  enabled: boolean;
  item: string;
  code: string;
  shortName: string;
  description: string;
  listOrder: number;
}

export const updateEhsListItemMutation = (
  input: UpdateEhsListItemInput
): QueryConfig => {
  const query = `mutation ($input: UpdateEhsListItemInput!) {
    updateEhsListItem (input: $input) {
      id
      item
      listTypeCode
      enabled
    }
  }`;
  return {
    query,
    variables: { input },
  };
};
